import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { totalPublicationsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { dealwithCommonDate, useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import BubbleCommon, {
  totalPublicationsFilterTips,
} from '@op/components/BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function TotalPublicationSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'publications',
      subDefaultKey: 'publication',
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 5', value: '0-5' },
        { text: '5 ~ 10', value: '5-10' },
        { text: '10 ~ 15', value: '10-15' },
        { text: '15+', value: '15-' },
      ],
      dealwithDateFunc: dealwithCommonDate,
    });
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      let dataItem: { start_publication: number; end_publication?: number } = {
        start_publication: Number(start),
      };
      if (end !== '') {
        dataItem['end_publication'] = Number(end);
      }
      data.push(dataItem);
    }

    onChange?.(
      'totalPublications',
      commonBackInfo({ publications: data }, { totalPublications: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <BubbleCommon
      placement="top"
      showIcon={false}
      tipsMap={totalPublicationsFilterTips}
    >
      <div className={`dbo-total-publication-wrapper ${diffClassName}`}>
        <CustomFollowerRange
          lang={lang}
          ref={followerRef}
          options={options}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          unit=""
          placeholder={totalPublicationsPlaceholder}
          pointKey={FilterButtonPoint.totalPublications}
        ></CustomFollowerRange>
      </div>
    </BubbleCommon>
  );
}
